<template>
  <div v-loading="loading" element-loading-text="加载中">
    <el-row>
      <el-col :span="9">
        <div id="charts-box-copy-l"></div>

        <div id="legend">
          <div v-for="(p, index) in firstLabelList" class="item">
            <div class="label">{{ p.name }}</div>
            <div :class="'value' + index">{{ p.value }}</div>
          </div>
          <div class="line"></div>
          <div v-for="(p, index) in secondLabelList" class="item">
            <div class="label">{{ p.name }}</div>
            <div :class="'second' + index">{{ p.value }}</div>
          </div>
        </div>
      </el-col>

      <el-col :span="15">
        <div class="element-select">
          <el-select v-model="value" @change="registerCount" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div id="charts-box-copy-lbar"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import echarts from "echarts";
import { API__code, API_control } from "../../../api/index.js";
export default {
  data() {
    return {
      chartsXAxis: [],
      //折线图数据
      chartsData: [],
      chart: {
        x: [],

      },
      value: "1",
      loading: false,
      options: [
        {
          value: "1",
          label: "最近一个月",
        },
        {
          value: "3",
          label: "最近三个月",
        },
        {
          value: "6",
          label: "最近半年",
        },
        {
          value: "12",
          label: "最近一年",
        },
      ],
      chartPie: [],
      firstLabelList: [],
      secondLabelList: [],
      pieList: [],
      token: "",
      checkCode: "",
      officalList: [],//柱状图 正式用户数
      tryList: []//柱状图 试用用户数
    };
  },
  created() { },
  mounted() {
    this.getCookie();
    this.getData();
  },
  methods: {
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          }
        }
      }
    },

    getData() {
      this.registerCount();
    },

    registerCount(val) {
      var param = {
        count: this.value,
        token: this.token,
        checkCode: this.checkCode,
      };
      this.loading = true;
      API_control.registerCount(param).then((res) => {
        if (res.data.code == 200) {
          this.chart.x = res.data.data.x;
          let offical = []
          let tryList = []
          res.data.data.y.map(item => {
            let list = item.split(',')
            offical.push(list[0])
            tryList.push(list[1])
          })
          this.officalList = offical
          this.tryList = tryList
          this.firstLabelList = [
            { name: "正式授权(活跃)", value: res.data.proActiveCount },
            { name: "正式授权(不活跃)", value: res.data.proInactiveCount },
            { name: "总数", value: res.data.proCount },
          ];
          this.secondLabelList = [
            { name: "试用授权(活跃)", value: res.data.testActiveCount },
            { name: "试用授权(不活跃)", value: res.data.testInactiveCount },
            { name: "总数", value: res.data.testCount },
          ];
          this.chartPie = [
            { name: "正式授权(活跃)", value: res.data.proActiveCount },
            { name: "正式授权(不活跃)", value: res.data.proInactiveCount },
            { name: "试用授权(活跃)", value: res.data.testActiveCount },
            { name: "试用授权(不活跃)", value: res.data.testInactiveCount },
          ];
          this.initCharts();
          this.initBar();
          this.loading = false;
        }
      });
    },

    initCharts() {
      var charts = null;
      charts = echarts.init(document.getElementById("charts-box-copy-l"));
      charts.showLoading(); //显示等待框
      charts.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        title: {
          text: "注册用户情况统计",
          top: "top",
          left: "left",
          textStyle: {
            color: "#666666",
            fontSize: 16,
            fontWeight: 500,
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "0%",
          containLabel: true,
        },
        series: [
          {
            name: "注册用户情况统计",
            type: "pie",
            radius: ["40%", "58%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
            },
            // 鼠标移上去的item不会凸出了
            hoverAnimation: false,
            emphasis: {
              label: {
                show: true,
                formatter: function (params) {
                  return (
                    "{nm|" +
                    params.data.name +
                    "}" +
                    "\n\n{p|" +
                    params.data.value +
                    "}"
                  );
                },
                rich: {
                  p: {
                    fontSize: 20,
                    backgroundColor: "white",
                    color: "#666666",
                    fontWeight: "700",
                  },
                  nm: {
                    color: "#666666",
                    fontSize: 14,
                    backgroundColor: "white",
                    fontWeight: "400",
                  },
                },
              },
            },
            labelLine: {
              show: false,
            },
            center: ["45%", "50%"],
            data: this.chartPie,
          },
        ],
        color: ["#669DF0", "#1D55AA", "#BE74D9", "#6D3780"],
      });
      charts.hideLoading(); //隐藏等待框
      //this.loading = false;
      let index = 0;
      let myChart = charts;
      myChart.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex: 0,
      });
      myChart.on("mouseover", function (e) {
        if (e.dataIndex != index) {
          myChart.dispatchAction({
            type: "downplay",
            seriesIndex: 0,
            dataIndex: index,
          });
        }
      });
      myChart.on("mouseout", function (e) {
        index = e.dataIndex;
        myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: e.dataIndex,
        });
      });
    },

    initBar() {
      var echartsbar = echarts.init(
        document.getElementById("charts-box-copy-lbar")
      );
      echartsbar.clear();
      echartsbar.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        title: {
          text: "新注册用户统计",
          top: "top",
          left: "left",
          textStyle: {
            color: "#666666",
            fontSize: 16,
            fontWeight: 500,
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "0",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.chart.x,
            axisLine: {
              lineStyle: {
                color: "#EBEBEB",
              },
            },
            axisLabel: {
              show: true,
              // interval: 0,

              textStyle: {
                color: "#6E6E6E",
              },
            },
          },
        ],

        yAxis: [
          {
            type: "value",
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
              alignWithLabel: false,
            },
            axisLine: {
              lineStyle: {
                color: "#EBEBEB",
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#596471",
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "正式用户",
            type: "bar",
            stack: "one",
            barMaxWidth: 24,
            data: this.officalList,
          },
          {
            name: "试用用户",
            type: "bar",
            stack: "one",
            barMaxWidth: 24,
            data: this.tryList,
          },
        ],
        // 底部Zoom
        dataZoom: {
          type: 'inside',
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0],
        },
        color: ["#669DF0", "#BE74D9"],
      });
    },
  },
};
</script>

<style scoped lang="scss">
#charts-box-copy-l {
  width: 100%;
  height: 336px;
  background-color: white;
  border-radius: 2px;
}

.element-select {
  float: right;
  position: relative;
  z-index: 888;
}

#legend {
  width: 120%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  top: -20px;

  .line {
    width: 77%;
    height: 0px;
    border: 1px dashed #dbdbdb;
    margin: 13px 0 11px 0;
  }

  .item {
    width: 33.3%;
    display: flex;
    flex-direction: column;

    .label {
      width: 100%;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      margin-bottom: 8px;
    }

    .value0 {
      font-weight: 700;
      font-size: 20px;
      color: #669df0;
    }

    .value1 {
      font-weight: 700;
      font-size: 20px;
      color: #1d55aa;
    }

    .value2 {
      font-weight: 700;
      font-size: 20px;
      color: #666666;
    }

    .second0 {
      font-weight: 700;
      font-size: 20px;
      color: #be74d9;
    }

    .second1 {
      font-weight: 700;
      font-size: 20px;
      color: #6d3780;
    }

    .second2 {
      font-weight: 700;
      font-size: 20px;
      color: #666666;
    }
  }
}

#charts-box-copy-lbar {
  width: 100%;
  height: 450px;
  background-color: white;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// leftCharts.vue?b9f9fb7a